class i4_Tab {
	constructor(element) {
		this.$element = $(element);
		this.barButtons = [];

		this.selectors = {
			item: '.js-tab-item'
		};

		this.classNames = {
			bar: 'i4-tab__bar',
			barButton: 'i4-tab__bar-button',
			content: 'i4-tab__content'
		};

		this.data = {
			itemName: 'name'
		};

		this.modifiers = {
			buttonActive: 'i4-button i4-button--primary i4-tab__bar-button--active'
		};
	}

    init() {
		this.$items = this.$element.find(this.selectors.item);

		if (this.$items.length > 0) {
			this.initTabs();
			$(this.barButtons[0]).trigger('click');
		} else {
			console.warn('No Tab items found.');
		}
	}

	initTabs() {
		const $bar = $('<div></div>').addClass(this.classNames.bar);

		this.$items.each((i, item) => {
			const $item = $(item);
			$item.addClass(this.classNames.content);

			const $barButton = $('<div></div>')
				.addClass(this.classNames.barButton)
				.text($item.data(this.data.itemName))
				.on('click', () => {
					this.$items.hide();
					$item.show();

					this.barButtons.map(button => $(button).removeClass(this.modifiers.buttonActive));
					$barButton.addClass(this.modifiers.buttonActive);
				});

			$bar.append($barButton);
			this.barButtons.push($barButton);
		});

		this.$element.prepend($bar);
	}
}

i4_Decorator_loader.registerClass('i4_Tab', i4_Tab);
